// extracted by mini-css-extract-plugin
var _1 = "MentionForm_item__c9452";
var _2 = "MentionForm_root__12b5e";
var _3 = "MentionForm_selected__d5b03";
export { _1 as "item", _2 as "root", _3 as "selected" }
